import { getEnvironmentConfig, getEnvVariableDefault } from '../configHelper.js';
const definition = {
    base: {
        clientLibraryUrl: 'https://sbx01-frontend.engagently.com/engagently.js',
        communityId: 'foS867d78s',
        communitySecret: getEnvVariableDefault('CONVERSARIO_SECRET', ''),
        burdaLoginUrl: 'https://login-sandbox.burda-forward.de/',
    },
    production: {
        clientLibraryUrl: 'https://ffcs4u.engagently.com/engagently.js',
        communityId: 'foPd577522',
        burdaLoginUrl: 'https://login.burda-forward.de/',
    },
};
export const conversarioConfig = () => getEnvironmentConfig(definition);
//# sourceMappingURL=conversario.config.js.map